import type { components } from '@pba/types-openapi-client';

export type Image = {
  downloadUrl?: string;
  filename?: string;
  id: string;
  url: string;
};

export const createImage = (data: components['schemas']['File']): Image => ({
  downloadUrl: data.download_url,
  filename: data.filename,
  id: data.id,
  url: data.url,
});
